const brandInfo = {
    lawnstarter: {
        displayName: 'LawnStarter',
        domain: 'lawnstarter.com',
        phone: {
            raw: '8668221766',
            formatted: '1-866-822-1766',
        },
        links: {
            terms: 'https://lawnstarter.com/terms-of-service',
            privacy: 'https://lawnstarter.com/privacy',
        },
    },

    lawnlove: {
        displayName: 'Lawn Love',
        domain: 'lawnlove.com',
        phone: {
            raw: '8662068069',
            formatted: '1-866-206-8069',
        },
        links: {
            terms: 'https://lawnlove.com/terms',
            privacy: 'https://lawnlove.com/privacy',
        },
    },

    // TODO: update homegnome info below
    homegnome: {
        displayName: 'HomeGnome',
        domain: 'homegnome.com',
        phone: {
            raw: '8662068069',
            formatted: '1-866-206-8069',
        },
        links: {
            terms: 'https://homegnome.com/terms',
            privacy: 'https://homegnome.com/privacy',
        },
    },
};

export default {
    computed: {
        isLawnStarter() {
            return process.env.VUE_APP_BRAND === 'lawnstarter';
        },
        isLawnLove() {
            return process.env.VUE_APP_BRAND === 'lawnlove';
        },
        isHomeGnome() {
            return process.env.VUE_APP_BRAND === 'homegnome';
        },
        brand() {
            return brandInfo[process.env.VUE_APP_BRAND].displayName;
        },
        phoneRaw() {
            return brandInfo[process.env.VUE_APP_BRAND].phone.raw;
        },
        phoneFormatted() {
            return brandInfo[process.env.VUE_APP_BRAND].phone.formatted;
        },
        domain() {
            return brandInfo[process.env.VUE_APP_BRAND].domain;
        },
        links() {
            return brandInfo[process.env.VUE_APP_BRAND].links;
        },
    },
};
